import React, { useEffect, useState } from 'react'
import vehicleApi from './api/vehicle.api'
import Map from './components/Map'
import SearchBox from './components/SearchBox'
import { IdType, VehiclePosition } from './types'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import { AxiosError } from 'axios'

let timeout: NodeJS.Timeout

function App(): JSX.Element {
  const [id, setId] = useState<string>('')
  const [selectedIdType, setSelectedIdType] = useState<IdType>('vehicleId')
  const [vehicles, setVehicles] = useState<VehiclePosition[]>()
  const [timestamp, setTimestamp] = useState<string>(new Date().toISOString())
  const [isSearching, setSearching] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean>(true)
  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout)
    }
    const sideEffect = async () => {
      if (id.length > 0) {
        try {
          setSearching(true)
          const data = await vehicleApi.getVehicles(id, selectedIdType)
          setSearching(false)
          setVehicles(data)
          if (refresh) {
            timeout = setTimeout(sideEffect, 15000)
          }
        } catch (error) {
          console.error(error)
          setSearching(false)
          let message = 'Ongeldig antwoord van server.'

          if (error instanceof AxiosError) {
            message =
              error.response?.status === 404
                ? `Geen voertuig gevonden met ${selectedIdType}: ${id}`
                : 'Ongeldig antwoord van server.'
          }

          toast.error(message, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      }
    }
    sideEffect()
  }, [id, selectedIdType, timestamp, refresh])

  return (
    <div className="App">
      <Map vehicles={vehicles} />
      <SearchBox
        isSearching={isSearching}
        setRefresh={setRefresh}
        refresh={refresh}
        handleSearch={(input: string, id: IdType) => {
          setId(input)
          setSelectedIdType(id)
          setTimestamp(new Date().toISOString())
        }}
      />
      <ToastContainer />
    </div>
  )
}

export default App
